import script from "./footerBar.vue?vue&type=script&setup=true&lang=js"
export * from "./footerBar.vue?vue&type=script&setup=true&lang=js"

import "./footerBar.vue?vue&type=style&index=0&id=147e5ed7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\me\\OneDrive\\桌面\\HTML\\graduate_project_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-147e5ed7"]])

export default __exports__